import { Node_Type } from "./../../ricos-types/index.js";
import Button from "./button.js";
const nodeViewRenderers = {
  [Node_Type.BUTTON]: Button
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
